import { Component, ElementRef, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { Router } from '@angular/router';
import { decompress } from 'lz-string';
import { Subject, BehaviorSubject, fromEvent, takeUntil, map, Observable, combineLatest, startWith, shareReplay, switchMap, merge, of, throwError } from 'rxjs';
import { LikutConcentratedLine, LikutMainSQL, LikutStatus, LikutSubSQL, LikutUsers } from 'src/app/Interfaces/likut';
import { ResponseFromExpress } from 'src/app/Interfaces/SQL-interfaces';
import { AllClients } from 'src/app/Interfaces/SQL-morning-responses';
import {
	TruckDistributionManageReturnResponse,
	TruckDistributionNotFulfilled,
	TruckDistributionPODSupplied,
	TruckDistributionSubSQL,
	TruckDistributionUsers,
} from 'src/app/Interfaces/truck-distribution';
import { TruckLoadingAssignmentTable, TruckLoadingMainSQL, TruckLoadingUsers } from 'src/app/Interfaces/truck-loading';
import { BottomPopupService } from 'src/app/services/bottom-popup.service';
import { LikutService } from 'src/app/services/likut.service';
import { LoadingService } from 'src/app/services/loading.service';
import { StoreService } from 'src/app/services/store.service';
import { TextService } from 'src/app/services/text.service';
import { TruckDistributionService } from 'src/app/services/truck-distribution.service';
import { TruckLoadingService } from 'src/app/services/truck-loading.service';
import { UtilService } from 'src/app/services/util.service';
import { genericSearchingFunction, genericSearchingFunctionWithoutNullChecks } from 'src/app/Utility/functions';
import { environment } from 'src/environments/environment';

import { StorageService } from 'src/app/services/storage.service';
import { AlertService } from 'src/app/services/alert.service';
import { FormattedLog } from 'src/app/Utility/FormattedConsole';
import { HttpClient, HttpParams } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { TruckDistributionDriversPopupComponent, TruckDistributionDriversPopupMode } from './truck-distribution-drivers-popup/truck-distribution-drivers-popup.component';
import { Users } from 'src/app/Interfaces/users';

@Component({
	selector: 'app-truck-distribution-drivers',
	templateUrl: './truck-distribution-drivers.component.html',
	styleUrls: ['./truck-distribution-drivers.component.scss'],
})
export class TruckDistributionDriversComponent implements OnInit, OnDestroy {
	_ss = inject(StoreService);
	_likut = inject(LikutService);
	_truckLoading = inject(TruckLoadingService);
	_text = inject(TextService);
	_util = inject(UtilService);
	_truckDistribution = inject(TruckDistributionService);

	private matDialog = inject(MatDialog);
	private router = inject(Router);
	private fb = inject(FormBuilder);
	private _loading = inject(LoadingService);
	private _bottomPopup = inject(BottomPopupService);
	private _storage = inject(StorageService);
	private http = inject(HttpClient);
	constructor() {}

	minDate = new Date();

	form = this.fb.nonNullable.group({
		FromDate: ['', Validators.required],
		ToDate: ['', [Validators.required, Validators.min(this.minDate.getTime())]],
		Agent: [<string[]>[]],
		Status: [<string[]>[]],
		areas: [<string[]>[]],
		ClientSearch: [''],
		filterColumn: [<string[]>[]],
		filterColumn2: [<string[]>[]],
	});

	search$ = this.form.controls.ClientSearch.valueChanges.pipe(startWith(''));

	Admin;

	windowWidth: number;
	history = history;

	destroy$: Subject<void> = new Subject();

	drivers$ = this._truckDistribution.drivers$;
	// driversDisplay$ = this.drivers$.asObservable();
	driversDisplay$ = combineLatest([this.drivers$, this.search$]).pipe(
		map(([drivers, search]) => {
			if (!search) return drivers;
			return drivers.filter(driver => driver.UserName.includes(search));
		}),
	);

	AllClients: Record<string, { Client_Name: string; Client_Id: string }> = {};
	AllClientsFull$ = new BehaviorSubject<AllClients[]>([]);

	pageMode$ = new BehaviorSubject<'manage-drivers'>('manage-drivers');

	title$ = this.pageMode$.pipe(
		map(mode => {
			switch (mode) {
				case 'manage-drivers':
					return this._text.store.manageDriversTruckDistribution;
				default:
					return '';
			}
		}),
	);

	filterPrintDisplay$ = this.form.controls.filterColumn.valueChanges.pipe(
		startWith([]),
		map(filters => {
			return `סינון: ${filters.length ? filters.join(' , ') : 'ללא'}.`;
		}),
		shareReplay(1),
	);

	scrollY = 0;

	tableHeight: string | number = '';

	totalShown$ = combineLatest([this.driversDisplay$]).pipe(map(arrays => arrays.reduce((acc, curr) => acc + curr?.length || 0, 0)));

	shouldShowExternalPrintButton$ = new BehaviorSubject(false);

	async ngOnInit() {
		// this.checkIfHasPrintingEndpoint();

		// this._ss.OneClientInfoDebt = null;

		// if (location.pathname.includes('only-agent')) {
		// 	this.isOnlyAgent$.next(true);
		// }
		//////////////////// ---------- CLIENT INFORMATION ---------- ////////////////////
		if (this._ss.CustomerInformation === null) {
			if (localStorage.getItem('CustomerInformation') !== null) {
				this._ss.CustomerInformation = decompress(localStorage.getItem('CustomerInformation'));
				this._ss.CustomerInformation = JSON.parse(this._ss.CustomerInformation);
			}
		}

		if (localStorage.getItem('UserName') !== null && localStorage.getItem('AgentId') !== null) {
			this._ss.UserNameConnected = localStorage.getItem('UserName');
			this._ss.AgentIdConnected = localStorage.getItem('AgentId');
		} else {
			this.router.navigate(['login']);
			return;
		}
		//////////////////// ---------- CLIENT INFORMATION ---------- ////////////////////

		if (localStorage.getItem('Admin') !== null) {
			this.Admin = localStorage.getItem('Admin');
		}

		this.windowWidth = window.innerWidth;

		if (environment.development) {
			fromEvent(window, 'resize')
				.pipe(takeUntil(this.destroy$))
				.subscribe((evt: any) => {
					this.windowWidth = evt.currentTarget.innerWidth;
				});
		}

		this.getInitialData();
		window.scrollTo(0, 0);

		// await this.updateTasks();

		setTimeout(() => {
			const [header, filterRow] = document.querySelectorAll('header, .filter-row');

			const buttonHeight = 60;

			let height = header.getBoundingClientRect().height;
			height += buttonHeight;

			if (filterRow) {
				height += filterRow.getBoundingClientRect().height;
			}

			// zoom: 1.2
			if (this.windowWidth > 767 && this.windowWidth < 1099) {
				height *= 2.2;
			}
			this.tableHeight = height + 'px';
		}, 0);
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
		document.body.classList.remove('no-scroll');
		this._loading.changeLoadingStatuses({ isLoading: false });
	}

	checkIfHasPrintingEndpoint() {
		const params = new HttpParams({ fromObject: { checkIfExistsInIndex: true } });
		this.http.post(`${this._ss.CustomerInformation.CustServer}/mobil/dynamic-printable-report/create-and-print`, {}, { params }).subscribe({
			next: res => {
				this.shouldShowExternalPrintButton$.next(true);
			},
			error: () => {
				this.shouldShowExternalPrintButton$.next(false);
			},
		});
	}

	shouldClientCardPopupShow = false;

	toggleClientCardPopup(clientID?: string) {
		if (!clientID) {
			this._ss.OneClientInfoDebt = null;
			this.shouldClientCardPopupShow = false;
			document.body.classList.remove('no-scroll');
			return;
		}
		this.scrollY = window.scrollY;
		const client = this.AllClientsFull$.value.find(ac => ac.ClientId == clientID);
		if (client) {
			document.body.classList.add('no-scroll');
			this.shouldClientCardPopupShow = true;
			this._ss.OneClientInfo = client;
			setTimeout(() => {
				window.scrollTo({ top: this.scrollY });
			}, 0);
		}
	}

	Restart() {
		window.location.reload();
	}

	async updateDrivers() {
		this._ss.closeMenu();
		await new Promise<void>(async (resolve, reject) => {
			this._loading.changeLoadingStatuses({ newMessage: `${this._text.store.updatingTasks}...` });

			this._loading.changeLoadingStatuses({ isLoading: false });

			return;
		});
	}

	getAllClients() {
		if (!this._storage.getAndParseFromStorage('AllClients', { onlyCheckIfExist: true })) {
			alert('אנא עדכן נתונים');
			this.router.navigate(['home']);
			return;
		}

		this.AllClientsFull$.next(JSON.parse(decompress(localStorage.getItem('AllClients'))));
	}

	getInitialData() {
		switch (this.pageMode$.value) {
			case 'manage-drivers':
				if (!this.drivers$.value.length) {
					this._truckDistribution.updateDistributionUsers();
				}
				break;

			default:
				break;
		}
	}

	handleRowClick(payload: { action: TruckDistributionDriversPopupMode; row?: TruckDistributionUsers; e?: Event } = { action: 'add' }) {
		const { action, row, e } = payload;
		if (e) {
			e.stopPropagation();
		}
		if (action === 'edit' && !row) return;

		this.matDialog.open(TruckDistributionDriversPopupComponent, {
			data: { mode: action, row },
		});
	}

	sendExternalPrint() {
		let endpoint = '/mobil/dynamic-printable-report/create-and-print';

		if (environment.development) {
			endpoint = 'http://localhost:1000' + endpoint;
		} else {
			endpoint = this._ss.CustomerInformation.CustServer + endpoint;
		}

		const body = this.preparePrintData();

		body.payload.extraCSS = `
		th{
			border-bottom: 1px solid black;
			text-align:start;
		}
`;

		this.pipeADestroyer(this.http.post(endpoint, body)).subscribe({
			next: res => {
				console.log(res);
				this._bottomPopup.show('דוח נשלח להדפסה');
			},
			error: () => {
				alert('לא ניתן להדפיס את הדוח');
			},
		});
	}

	preparePrintData(): { payload: { title: string; subtitle: string; extraCSS?: string; columns: { displayColumnName: string; extraCSS?: string; data: any[] }[]; totalRows: number } } {
		let data = [];

		// (this.pageMode$.value === 'manage-returns' ? of([]) : this.teudotItemsDisplayNewRouteShown$).subscribe({
		// 	next: value => (data = value),
		// 	error: () => {
		// 		alert('לא ניתן להדפיס את הדוח');
		// 	},
		// });

		return {
			payload: {
				// title: this.title,
				title: '',
				subtitle: this.getPrinterSubstitle(),
				columns: this.preparePrinterValues(data),
				totalRows: data.length,
			},
		};
	}

	// setupTableData() {}

	preparePrinterValues(data: LikutConcentratedLine[] | TruckDistributionManageReturnResponse[]): {
		displayColumnName: string;
		data: any[];
	}[] {
		// if (this.isConcentratedReport) {
		// 	const finalValues = data as LikutConcentratedLine[];
		// 	const keyToColumnDisplay: Partial<Record<keyof LikutConcentratedLine, string>> = {
		// 		ProductId: 'מפתח',
		// 		Barcode: 'ברקוד',
		// 		ProductName: 'שם פריט',
		// 		TeudaQuantity: 'כמות',
		// 	};
		// 	return Object.keys(keyToColumnDisplay).map(key => ({
		// 		displayColumnName: keyToColumnDisplay[key],
		// 		data: finalValues.map(value => value[key]),
		// 	}));
		// }

		return [];
	}

	getPrinterSubstitle() {
		let sub = '';
		// if (this.isConcentratedReport) {
		// 	return 'דוח ריכוז';
		// }

		if (this.form.controls.filterColumn.value?.length) {
			sub += `
			סוכנים: ${this.form.controls.filterColumn.value.join(', ')}`;
		}
		if (this.form.controls.filterColumn2.value?.length) {
			sub += `
			סינון לפי: ${this.form.controls.filterColumn2.value.join(', ')}`;
		}

		if (this.form.controls.ClientSearch.value) {
			sub += `
			שדה חיפוש: '${this.form.controls.ClientSearch.value}'`;
		}

		return sub;
	}

	pipeADestroyer<T>(storeServiceMethod: Observable<T>) {
		return this._util.pipeASubjectDestoryer(storeServiceMethod, this.destroy$);
	}
}
